import analytics from 'client/analytics';
import {
  ANALYTICS_EVENT_SUGGESTED_SEARCH_FILTERS_CLICK,
} from 'client/analytics/eventList';
import ListingActions from 'client/actions/Listing';
import log from 'client/lib/log';

const debug = log.debug('sunroom:Search:applySuggestedFilter');

export default async function applySuggestedFilter({ state }, { suggestedSearchFilter }) {
  debug('Appling filters', suggestedSearchFilter.searchFilters);
  const currentViewedListings = state.get(['listingsMapView', 'viewedListings']);
  const currentUserSearchFilters = state.get(['currentUser', 'searchFilters']);
  const currentTotalListingsCount = state.get(['listings', 'totalListingsCount']);

  state.set(['currentUser', 'searchFilters'], suggestedSearchFilter.searchFilters);
  state.set(['search', 'filters'], suggestedSearchFilter.searchFilters);
  state.set(['search', 'selectedSuggestedSearchFilter'], suggestedSearchFilter);

  await ListingActions.reset({ state });

  state.set(['listingsMapView', 'mapChanged'], false);
  state.set(['listingsMapView', 'showResultsMatched'], true);
  state.set(['listingsMapView', 'viewedListings'], currentViewedListings);
  state.set(['listings', 'totalListingsCount'], currentTotalListingsCount);
  state.set(['currentUser', 'previousSearchFilters'], currentUserSearchFilters);
  state.commit();

  analytics.track(ANALYTICS_EVENT_SUGGESTED_SEARCH_FILTERS_CLICK, {
    suggestedSearchFilterId: suggestedSearchFilter.id,
  });
}
